export const organisations: TableModule = {
    name: "organisations",
    route: "spa.organisations",
    columns: [
        {
            name: "name",
            pageLink: true,
            sortable: true,
            sortBy: "name",
            mobile: true
        },
        {
            name: "city",
            sortable: true,
            sortBy: "city",
            breakpoint: "lg",
        },
        {
            name: "sport_name",
            sortable: true,
            sortBy: "sport_id",
            breakpoint: "md",
        }
    ],
    filters: [
        {
            name: "sport",
            column: "sport_id",
            type: "select",
            reduced: 'in',
            options: () => $lara.get(
                useNuxtApp().$apiRoute('spa.basicData.sportSelect.index')
            ).then(response => response.data?.map(
                (sport: { id: number, name: string }) => ({
                    value: sport.id,
                    label: sport.name
                }))
            ),
            ability: ['viewAny', 'sports']
        }
    ],
    quickFilters: [
        {
            name: "withRegistrations",
            column: "customFilterRegistrations",
            value: true,
            operator: "=",
            default: true,
        },
    ],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "organisations"]
        },
        {
            name: "general.export"
        }
    ]
}
